import React from 'react';
import {
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

function ContactsDropdownNewContactButton({
  onClick,
  query,
}: {
  query: string;
  onClick: (s: string) => any;
}) {
  return (
    <List data-cy="contacts-dropdown-create-contact-button">
      <ListItemButton
        role="option"
        onClick={() => onClick(query)}
        data-cy="dropdown-item"
      >
        <ListItemIcon>
          <AddIcon />
        </ListItemIcon>
        <ListItemText>Create new contact named {query}</ListItemText>
      </ListItemButton>
    </List>
  );
}

export default ContactsDropdownNewContactButton;
